import '../Styles/Sass/Profile.scss';
import iconBadge from '../Images/iconBadge.svg';

function Profile(props){

  const completedJobs = () => {
    if (props.jobs) {
      let jobsCompleted = 0;
      props.jobs.forEach(job => {
        if (job.status === 'completed') {
          jobsCompleted++;
        }
      });
      return jobsCompleted;
    }
  }

  return(
    <section className='profile'>
      <div className='profile__detailBox'>
        <h3 className='profile__title'>{props.name}'s Profile</h3>
        <h4 className='profile__subtitle profile__subtitle--head'>{props.headline}</h4>
        {
          props.job === 'cleaner' ?
          <>
            <h4 className='profile__subtitle'>{props.city}, {props.postal}, {props.province}</h4>
            <h4 className='profile__subtitle'>${props.rate} per hour</h4>
            <h4 className='profile__subtitle'>Completed {completedJobs()} Jobs</h4>
          </> :
          <>
            <h4 className='profile__subtitle'>Hired {props.hired()}</h4>
          </>
        }
      </div>
      <div className='profile__contactBox'>
        <button className='blueButton profile__button'><a href={`mailto:${props.email}`} >Contact Now</a></button>
        {
          props.whimis === true ?
            <div className='profile__checkBox'>
              <img className='profile__icon' src={iconBadge} alt="" />
              <h5 className='profile__validText'>WHIMIS Certified</h5>
            </div> :
            <>
            </>
        }
        {
          props.policecheck === true ?
            <div className='profile__checkBox profile__checkBox--police'>
              <img className='profile__icon' src={iconBadge} alt="" />
              <h5 className='profile__validText'>Police Check</h5>
            </div> :
            <>
            </>
        }
      </div>
    </section>
  );
}
export default Profile;